import { useEffect } from 'react';
import useWfProductService from 'src/api/wf/service/WfProductService';
import useWfWorkplaceService from 'src/api/wf/service/WfWorkplaceService';
import { useWfProductStore } from 'src/api/wf/stores/WfProductStore';
import { useWfTyphoonStore } from 'src/api/wf/stores/WfTyphoonStore';
import { useWfWorkplaceStore } from 'src/api/wf/stores/WfWorkplaceStore';
import InlineAlert from 'src/ui/wf/common/inlineAlert/InlineAlert';
import { SiteHeader } from './P7_1_SiteDetailsHeader';
import { InformationSection } from './P7_1_SiteDetailsInformationSection';
import { WideAreaDisasterSection } from './P7_1_SiteDetailsWideAreaSection';
import { ProductsSection } from './P7_1_SiteDetailsProductsSection';

const P7_1_SiteDetails = () => {
  const { selectedWorkplace } = useWfWorkplaceStore();
  const { products } = useWfProductStore();
  const { currentTyphoon } = useWfTyphoonStore();
  const { fetchProducts } = useWfProductService();
  const { fetchSelectedWorkplace } = useWfWorkplaceService();

  const branchCode = selectedWorkplace?.branchCode;
  const customerId = selectedWorkplace?.customerId;
  const disasterId = currentTyphoon?.id;

  useEffect(() => {
    if (!branchCode || !customerId || !disasterId) return;

    fetchProducts({
      branchCode,
      customerId,
      disasterId,
    });

    fetchSelectedWorkplace(branchCode, customerId, disasterId);
  }, [branchCode, customerId, disasterId, fetchProducts, fetchSelectedWorkplace]);

  return (
    <div className="flex flex-col space-y-4 p-2 md:p-4">
      <SiteHeader workplace={selectedWorkplace} />
      <InlineAlert />
      <div className="space-y-4">
        <InformationSection workplace={selectedWorkplace} />
        <WideAreaDisasterSection workplace={selectedWorkplace} />
        <ProductsSection products={products} />
      </div>
    </div>
  );
};

export default P7_1_SiteDetails;
